var map = {
	"./bigTruck/bigTruck-blue.svg": "87ee",
	"./bigTruck/bigTruck-dark-grey.svg": "0095",
	"./bigTruck/bigTruck-green.svg": "cd0e",
	"./bigTruck/bigTruck-grey.svg": "06ac",
	"./bigTruck/bigTruck-orange.svg": "cf7d",
	"./bigTruck/bigTruck-red.svg": "a7d0",
	"./bus/bus-blue.svg": "ba4d",
	"./bus/bus-dark-grey.svg": "9bda",
	"./bus/bus-green.svg": "6a7e",
	"./bus/bus-grey.svg": "4a52",
	"./bus/bus-orange.svg": "d38a",
	"./bus/bus-red.svg": "70c8",
	"./car/car-blue.svg": "11a5",
	"./car/car-dark-grey.svg": "df5e",
	"./car/car-green.svg": "e959",
	"./car/car-grey.svg": "ca90",
	"./car/car-orange.svg": "4296",
	"./car/car-red.svg": "2cc0",
	"./container/container-blue.svg": "3ee8",
	"./container/container-dark-grey.svg": "ffc5",
	"./container/container-green.svg": "322a",
	"./container/container-grey.svg": "601b",
	"./container/container-orange.svg": "6010",
	"./container/container-red.svg": "f408",
	"./electricCar/electricCar-blue.svg": "7f7d",
	"./electricCar/electricCar-dark-grey.svg": "73c7",
	"./electricCar/electricCar-green.svg": "e65a",
	"./electricCar/electricCar-grey.svg": "9f8f",
	"./electricCar/electricCar-orange.svg": "880f",
	"./electricCar/electricCar-red.svg": "0080",
	"./electricMotorcycle/electricMotorcycle-blue.svg": "a417",
	"./electricMotorcycle/electricMotorcycle-dark-grey.svg": "7a49",
	"./electricMotorcycle/electricMotorcycle-green.svg": "ddf1",
	"./electricMotorcycle/electricMotorcycle-grey.svg": "b10a",
	"./electricMotorcycle/electricMotorcycle-orange.svg": "8e11",
	"./electricMotorcycle/electricMotorcycle-red.svg": "4f0a",
	"./excavator/excavator-blue.svg": "abfe",
	"./excavator/excavator-dark-grey.svg": "e470",
	"./excavator/excavator-green.svg": "550f",
	"./excavator/excavator-grey.svg": "f075",
	"./excavator/excavator-orange.svg": "42be",
	"./excavator/excavator-red.svg": "2768",
	"./mixerTruck/mixerTruck-blue.svg": "54bf",
	"./mixerTruck/mixerTruck-dark-grey.svg": "69de",
	"./mixerTruck/mixerTruk-gray.svg": "da73",
	"./mixerTruck/mixerTruk-green.svg": "45cc",
	"./mixerTruck/mixerTruk-red.svg": "68f4",
	"./mixerTruck/mixerTruk-yellow.svg": "52de",
	"./motorcycle/motorcycle-blue.svg": "c5ef",
	"./motorcycle/motorcycle-dark-grey.svg": "888c",
	"./motorcycle/motorcycle-green.svg": "ad41",
	"./motorcycle/motorcycle-grey.svg": "9f7b",
	"./motorcycle/motorcycle-orange.svg": "2b2d",
	"./motorcycle/motorcycle-red.svg": "565d",
	"./person/person-blue.svg": "cf6a",
	"./person/person-dark-grey.svg": "9e15",
	"./person/person-green.svg": "d401",
	"./person/person-grey.svg": "d5e8",
	"./person/person-orange.svg": "fa72",
	"./person/person-red.svg": "d45b",
	"./smallTruck/smallTruck-blue.svg": "5668",
	"./smallTruck/smallTruck-dark-grey.svg": "2983",
	"./smallTruck/smallTruck-green.svg": "df7b",
	"./smallTruck/smallTruck-grey.svg": "cfb3",
	"./smallTruck/smallTruck-orange.svg": "9341",
	"./smallTruck/smallTruck-red.svg": "7e2e",
	"./tractor/tractor-blue.svg": "64a5",
	"./tractor/tractor-dark-grey.svg": "4bba",
	"./tractor/tractor-green.svg": "7292",
	"./tractor/tractor-grey.svg": "7fa5",
	"./tractor/tractor-red.svg": "b115",
	"./tractor/tractor-yellow.svg": "3f34",
	"./train/train-blue.svg": "dda7",
	"./train/train-dark-grey.svg": "1b46",
	"./train/train-green.svg": "b591",
	"./train/train-grey.svg": "0a3cc",
	"./train/train-red.svg": "22c6",
	"./train/train-yellow.svg": "5eaa",
	"./truckHead/truckHead-blue.svg": "26d2",
	"./truckHead/truckHead-dark-grey.svg": "4599",
	"./truckHead/truckHead-green.svg": "66d5",
	"./truckHead/truckHead-grey.svg": "473e",
	"./truckHead/truckHead-red.svg": "4e3b",
	"./truckHead/truckHead-yellow.svg": "9b91",
	"./van/van-blue.svg": "3c63",
	"./van/van-dark-grey.svg": "7db07",
	"./van/van-green.svg": "645f",
	"./van/van-grey.svg": "f913",
	"./van/van-orange.svg": "ca8e",
	"./van/van-red.svg": "3ac4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6561";